<template>
    <div>
      <div class="row">
        <div class="col-md-12">
          <div v-if="loading" class="col-md-12">
            <div class="loader-box">
              <div class="loader-30"></div>
            </div>
          </div>
          <div v-else class="col-md-12">
            <div class="logs-main-container">
              <!-- Header inside the container -->
              <div class="d-flex flex-nowrap justify-content-between align-items-center mt-3 pr-3 pl-3">
                <div>
                  <h2 class="logs-page-title custom-font-32 mb-0">Logs</h2>
                </div>
                <div>
                  <div class="per-page-info-box d-flex align-items-center">
                    <img src="@/assets/icons/per-page.svg" alt="Per page" class="per-page-icon mr-2" />
                    <span class="per-page-label">Per page : </span>
                    <div class="select-wrapper">
                      <b-form-select
                        class="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        @change="updatePerPage"
                      ></b-form-select>
                      <i class="icofont icofont-simple-down select-icon"></i>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Table Container with padding -->
              <div class="logs-table-container table-responsive-custom text-left">
                <b-table
                  class="logs-page-table custom-font-20"
                  borderless
                  show-empty
                  stacked="md"
                  :items="logs_data"
                  :filter="filter"
                  @filtered="onFiltered"
                  :fields="tablefields"
                  :per-page="perPage"
                >
                  <template #cell(ename)="data">
                    <span
                      v-if="data.item.ename == 'start'"
                      class="event-badge status-started custom-font-16"
                    >
                      <img src="@/assets/icons/color-started-icon.svg" alt="Started" width="16" height="16">
                      Started
                    </span>
                    <span
                      v-if="data.item.ename == 'pause'"
                      class="event-badge status-paused custom-font-16"
                    >
                      <img src="@/assets/icons/color-pause-icon.svg" alt="Pause" width="16" height="16">
                      Paused
                    </span>
                    <span
                      v-if="data.item.ename == 'down'"
                      class="event-badge status-down custom-font-16"
                    >
                      <img src="@/assets/icons/color-down-icon.svg" alt="Down" width="16" height="16">
                      Down
                    </span>
                    <span
                      v-if="data.item.ename == 'up'"
                      class="event-badge status-up custom-font-16"
                    >
                      <img src="@/assets/icons/color-up-icon.svg" alt="Up" width="16" height="16">
                      Up
                    </span>
                    <span
                      v-if="data.item.ename == 'stale'"
                      class="event-badge status-stale custom-font-16"
                    >
                      <img src="@/assets/icons/stale.svg" alt="Stale" width="16" height="16">
                      Stale
                    </span>
                  </template>
                  <template #cell(reason)="data">
                    <span class="reason-text">{{ data.item.reason }}</span>
                  </template>
                  <template #cell(timestamp)="data">
                    <span class="timestamp-text">{{ changeDateFormate(data.item.timestamp) }}</span>
                  </template>
                  <template #cell(rtime)="data">
                    <span class="response-time-text">{{convertMsToHM(data.item.rtime)}}</span>
                  </template>
                </b-table>
              </div>
              
              <!-- Pagination Component -->
              <div class="row">
                <div class="col-md-12">
                  <div class="simple-pagination-bar d-flex justify-content-between align-items-center mt-3 mb-1">
                    <span class="page-info-text custom-font-16">Page no. {{ currentPage }}</span>
                    <div class="pagination-btn-group d-flex align-items-center">
                      <button 
                        class="simple-page-btn mr-2"
                        :disabled="currentPage == 1"
                        @click="getLogs('prev', dateRanges)"
                      >
                        Previous
                      </button>
                      <button 
                        class="simple-page-btn"
                        :disabled="logs_data.length < perPage"
                        @click="getLogs('next', dateRanges)"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
  
<script>
import moment from 'moment'
import DashboardController from "../../services/dashboardController";
import HelperFunction from "../../services/helperFunction"
export default {
  name: "Event",
  props:{monitor_id:String,dateRanges:Object,update_filter:Number},
  data() {
    return {
      logs_data: [],
      filter: null,
      totalRows: 1,
      totalRowsCount: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 50, 100],
      loading: false,
      tablefields: [
      { key: "ename", label: "Event", sortable: false },
      { key: "reason", label: "Reason", sortable: false },
      { key: "rtime", label: "Time", sortable: false },
      { key: "timestamp", label: "Date", sortable: false },
      ],
    };
  },
  mounted() {
    this.getLogs('', this.dateRanges);
  },
  watch:{
    monitor_id(){
      this.currentPage = 1
      this.getLogs()
    },
    update_filter(){
        this.getLogs('', this.dateRanges)
    }
  },
  methods: {
    changeDateFormate(d){
        // Convert to local timezone and format consistently with Events.vue
        return moment(d + 'Z').format('D/M/YYYY, hh:mm A')
    },
    async getLogs(txt, dateRange = false) {
        dateRange = dateRange ? dateRange : this.dateRanges
        if(txt == 'next'){this.currentPage ++}
        if(txt == 'prev'){
          if(this.currentPage != 1){
            this.currentPage --
          }
        }
        if(this.monitor_id && this.monitor_id != null){
        let payload = {
          dim: {
            mid: [this.monitor_id]
          },
          limit: this.perPage,
          page: this.currentPage
        };
        if(dateRange){
            payload.sdate = dateRange.startDate
            payload.edate = dateRange.endDate
        }
        
      this.loading = true;
      let response = await DashboardController.getlogsdata(payload);
      if (response.result) {
        this.logs_data = response.data;
        this.totalRows = this.logs_data.length;
        // Set totalRowsCount from API response or fall back to current page length
        this.totalRowsCount = response.totalCount || response.total || this.logs_data.length;
      }
    }
      this.loading = false;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    convertMsToHM(millis) {
      return HelperFunction.convertMsToHM(millis)
    },
    updatePerPage() {
      this.currentPage = 1;
      this.getLogs();
    }
  },
};
</script>

<style scoped>
/* Main Container */
.logs-main-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 0 0 30px 0;
}

.logs-page-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  color: #161616;
  margin: 0;
}

/* Table Container */
.logs-table-container {
  width: 100%;
  overflow: hidden;
  margin-bottom: 0;
  padding: 0 !important;
}

/* Remove all borders from logs table */
.logs-main-container .logs-table-container {
  border: none !important;
  box-shadow: none !important;
}

.logs-main-container .logs-page-table.table {
  border: none !important;
  box-shadow: none !important;
}

.logs-main-container .logs-page-table >>> tr,
.logs-main-container .logs-page-table >>> td,
.logs-main-container .logs-page-table >>> th {
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
}

.logs-table-container .logs-page-table {
  border: none !important;
  border-radius: 20px !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  overflow: hidden;
  margin-top: 20px;
  width: 100% !important;
}

.logs-table-container .logs-page-table >>> thead th {
  padding: 15px 10px !important;
  font-family: 'Poppins', sans-serif;
  font-weight: 600 !important;
  font-size: 18px;
  color: #161616 !important;
  border-bottom: 1px solid #E5E7EB !important;
  background: #FFFFFF;
}

.logs-table-container .logs-page-table >>> thead th:first-child {
  padding-left: 30px !important;
}

.logs-table-container .logs-page-table >>> thead th:last-child {
  padding-right: 30px !important;
}

.logs-table-container .logs-page-table >>> tbody tr td {
  padding: 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  color: #161616;
  font-size: 16px;
  border-bottom: 1px solid #E5E7EB !important;
  vertical-align: middle;
}

.logs-table-container .logs-page-table >>> tbody tr td:first-child {
  padding-left: 30px !important;
}

.logs-table-container .logs-page-table >>> tbody tr td:last-child {
  padding-right: 30px !important;
}

.logs-table-container .logs-page-table >>> tbody tr:hover {
  background-color: #F9FAFB;
}

/* Event Badges */
.event-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px !important;
  border-radius: 20px;
  font-weight: 500;
  color: #FFFFFF;
  min-width: 100px;
  justify-content: center;
}

.event-badge img,
.event-badge svg {
  flex-shrink: 0;
}

.status-started {
  border-radius: 16px;
  background: rgba(0, 127, 231, 0.10);
  color: #007FE7;
}

.status-paused {
  border-radius: 16px;
  background: rgba(52, 64, 84, 0.10);
  color: #344054;
}

.status-down {
  border-radius: 16px;
  background: rgba(231, 0, 0, 0.10);
  color: #E70000;
}

.status-up {
  border-radius: 16px;
  background: rgba(47, 178, 52, 0.10);
  color: #2FB234;
}

.status-stale {
  border-radius: 16px;
  background: rgba(255, 152, 0, 0.10);
  color: #FF9800;
}

/* Text Styling */
.reason-text {
  font-family: 'Poppins', sans-serif;
  color: #3A3A3A;
  font-weight: 400;
  word-break: break-word;
  max-width: 300px;
  display: inline-block;
  line-height: 1.5;
}

.timestamp-text {
  font-family: 'Poppins', sans-serif;
  color: #3A3A3A;
  font-weight: 400;
}

.response-time-text {
  font-family: 'Poppins', sans-serif;
  color: #3A3A3A;
  font-weight: 500;
}

/* Pagination Styles */
.simple-pagination-bar {
  background: none;
  border: none;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-info-text {
  font-family: 'Poppins', sans-serif;
  color: #6B7280;
  font-weight: 500;
}

.pagination-btn-group {
  display: flex;
  align-items: center;
}

.simple-page-btn {
  padding: 8px 18px;
  border: 1px solid #D1D5DB;
  background: #FFFFFF;
  border-radius: 10px;
  font-size: 16px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  color: #374151;
  transition: all 0.2s;
  outline: none;
  box-shadow: none;
}

.simple-page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  color: #9CA3AF;
  background: #F3F4F6;
  border-color: #E5E7EB;
}

.simple-page-btn:not(:disabled):hover {
  background: #F3F4F6;
  border-color: #9CA3AF;
}

/* Per Page Selector Styles */
.per-page-info-box {
  background: #fff;
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  padding: 0px 10px;
  font-size: 16px;
  font-family: 'Inter', sans-serif;
  color: #344054;
  font-weight: 500;
  margin-left: 16px;
}

.per-page-icon {
  width: 20px;
  height: 20px;
}

.per-page-label {
  font-size: 16px;
  color: #344054;
  font-weight: 500;
}

.select-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}

.per-page-select {
  width: auto;
  border: none;
  background: transparent;
  font-size: 16px;
  font-weight: 500;
  padding: 0 10px 0 5px;
  color: #344054;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.per-page-select:focus {
  box-shadow: none;
  outline: none;
}

.select-icon {
  position: absolute;
  right: 2px;
  pointer-events: none;
  color: #344054;
  font-size: 18px;
}

/* Table responsive wrapper */
.table-responsive-custom {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Ensure all table text uses Poppins font */
.logs-page-table {
  font-family: 'Poppins', sans-serif;
}

/* Responsive Styles */
@media (max-width: 1200px) {
  .event-badge {
    min-width: 80px;
    font-size: 14px;
    padding: 3px 10px !important;
  }
  
  .event-badge img {
    width: 14px;
    height: 14px;
  }

  .reason-text {
    max-width: 200px;
  }
}

@media (max-width: 992px) {
  .reason-text {
    max-width: 150px;
  }
}

/* Responsive Styles */
@media (max-width: 768px) {
  /* Remove horizontal padding on mobile */
  .logs-main-container {
    padding: 0 10px 10px 10px;
  }
  
  /* Make table containers full width */
  .logs-table-container {
    margin: 0;
    border-radius: 12px !important;
  }
  
  /* Adjust table styles for mobile */
  .logs-table-container .logs-page-table {
    border-radius: 12px !important;
  }
  
  /* Smaller event badges */
  .event-badge {
    min-width: 70px;
    font-size: 11px !important;
    padding: 2px 8px !important;
    gap: 3px;
  }
  
  .event-badge img {
    width: 12px;
    height: 12px;
  }
  
  /* Text truncation for mobile */
  .reason-text {
    max-width: 100px;
    font-size: 12px !important;
  }
  
  /* Font size adjustments */
  .custom-font-32 {
    font-size: 20px !important;
  }
  
  .custom-font-16 {
    font-size: 12px !important;
  }
  
  /* Hide table borders on mobile for cleaner look */
  .table-responsive-custom {
    overflow-x: visible;
  }
  
  /* Use Bootstrap's stacked mode on mobile */
  .logs-page-table.b-table-stacked-md {
    border: none !important;
  }

  /* Adjust per page selector */
  .per-page-info-box {
    padding: 0 8px;
    font-size: 14px;
  }

  .per-page-icon {
    width: 16px;
    height: 16px;
  }

  .per-page-label,
  .per-page-select {
    font-size: 14px;
  }
}

/* Very small devices */
@media (max-width: 480px) {
  .logs-main-container {
    padding: 0 5px 5px 5px;
    border-radius: 12px;
  }
  
  /* Even smaller text for very small screens */
  .reason-text {
    max-width: 80px;
  }
  
  .event-badge {
    min-width: 60px;
    font-size: 10px !important;
  }

  /* Stack header elements on mobile */
  .d-flex.flex-nowrap {
    flex-wrap: wrap !important;
  }

  .per-page-info-box {
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>